import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import * as C from "./PrintCart.styles";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../../../redux/action/confirm";
import { isLoaded, isLoading } from "../../../../redux/action/loading";
import { priceComma } from "../../../../common/splicePrice";
import PostCode from "../../../../common/postcode";
import KakaoMap from "../../../map/Maptainer";
import { failAlert, successAlert } from "../../../../common/alert";
import CustomFileInput from "../../../../common/CustomFileInput";
import { smallPackagingAPI } from "../../../../api/smallPackaging";
import { autoPhoneFormat } from "../../../../common/util/checkout-validation";
import {
  closeDefaultModal,
  modifyDefaultModal,
  openDefaultModal,
} from "../../../../redux/action/defaultModal";
import Link from "next/link";

const PrintCart = ({
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
  userInfo,
  printCartItems,
  setPrintCartItems,
  userCompany,
  moveToList,
  closeDefaultModal,
  modifyDefaultModal,
  openDefaultModal,
}) => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [pickAddress, setPickAddress] = useState("");
  const [userInputs, setUserInputs] = useState({});
  const [infoFiles, setInfoFiles] = useState([]);
  // 선택 견적
  const [selectedItem, setSelectedItem] = useState([]);
  const [confirmItems, setConfirmItems] = useState([]);

  // 수량 변경
  const handleCnt = (e, pcode) => {
    const item = printCartItems.find((el) => el.pcode === pcode);
    if (Number(e.target.value) > 1000) return;
    if (Number(e.target.value) > 0) {
      item.cnt = e.target.value;
    } else {
      item.cnt = 1;
    }
    setPrintCartItems([...printCartItems]);
  };

  // 장바구니 삭제
  const deleteBasketItem = async (pcode) => {
    const content = {
      title: "삭제하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onAction: async () => {
        const index = printCartItems.findIndex((el) => el.pcode === pcode);
        printCartItems.splice(index, 1);
        setPrintCartItems([...printCartItems]);
        sessionStorage.setItem(
          "printCart",
          JSON.stringify([...printCartItems])
        );
        successAlert("삭제되었습니다.");
        closeConfirmModal();
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  // 입력 값 적용
  const onChangeUserInputs = (id) => (e) => {
    if (id === "phone" || id === "receipt_num") {
      setUserInputs({
        ...userInputs,
        [id]: e.target.value,
      });
      e.target.value = autoPhoneFormat(e.target.value);
      return;
    }

    setUserInputs({
      ...userInputs,
      [id]: e.target.value,
    });
  };

  const onChangeFiles = (files) => {
    setInfoFiles([...files]);
  };

  // 우편번호 검색
  const onClickHandleModal = () => {
    setIsOpen((prev) => !prev);
  };
  const onCompletePostCode = (postcode) => {
    setPickAddress(postcode.address);
    setUserInputs({
      ...userInputs,
      addressLoad:
        postcode.roadAddress !== ""
          ? postcode.roadAddress
          : postcode.autoRoadAddress,
      addressJibun:
        postcode.jibunAddress !== ""
          ? postcode.jibunAddress
          : postcode.autoJibunAddress,
      addressCode: postcode.zonecode,
    });
    setIsOpen(false);
  };

  // 견적 선택
  const selectItem = (i, el) => (e) => {
    const tempArr = [...selectedItem];
    tempArr[i] = e.target.checked;
    setSelectedItem(tempArr);
    if (e.target.checked) {
      const tempArr2 = [...confirmItems];
      tempArr2[i] = el;
      setConfirmItems(tempArr2);
    } else {
      const tempArr2 = [...confirmItems];
      tempArr2[i] = undefined;
      setConfirmItems(tempArr2);
    }
  };

  // 견적 요청
  const confirmCustomizing = async () => {
    if (printCartItems.filter((el) => el !== undefined).length < 1) {
      return failAlert("선택한 견적이 없습니다.");
    }
    if (printCartItems.length === 0 || printCartItems == undefined) {
      return failAlert("요청할 견적이 없습니다.");
    }
    const body = {
      modes: "InsertSet",
      usages: userInputs.productInfo ? userInputs.productInfo : "",
      company: userInputs.company || userCompany?.name,
      name: userInputs.name || userInfo?.Member?.name,
      tel: userInputs.phone || userInfo?.Member?.phone,
      email: userInputs.email || userInfo?.Member?.email,
      zipcode: userInputs.addressCode || userCompany?.zipcode,
      doro_addr: userInputs.addressLoad || userCompany?.doro_addr,
      base_addr: userInputs.addressJibun || userCompany?.base_addr,
      detail_addr: userInputs.detail_addr || userCompany?.detail_addr,
      mapx: userInputs.addressGps?.mapx || userCompany?.mapx,
      mapy: userInputs.addressGps?.mapy || userCompany?.mapy,
      content: userInputs?.content ? userInputs.content : "",
      files: infoFiles,
      items: JSON.stringify(printCartItems.filter((el) => el !== undefined)),
      editYn: userInputs.editYn || "TYPE0",
      message: (userInputs.message || userInfo?.Member?.message || "").trim(), //배송 메세지
    };

    if (
      body.company === "" ||
      body.company === undefined ||
      body.name === "" ||
      body.name === undefined ||
      body.tel === "" ||
      body.tel === undefined ||
      body.email === "" ||
      body.email === undefined
    ) {
      return failAlert("담당자 정보를 입력하세요.");
    }
    if (
      body.zipcode === "" ||
      body.zipcode === undefined ||
      body.doro_addr === "" ||
      body.doro_addr === undefined ||
      body.detail_addr === "" ||
      body.detail_addr === undefined
    ) {
      return failAlert("배송지 정보를 입력하세요.");
    }
    if (body.editYn !== "TYPE2" && body.files.length < 1) {
      return failAlert("로고 혹은 도안파일을 업로드해주세요.");
    }

    modifyDefaultModal({
      show: true,
      actionBtnActive: true,
      actionBtnLabel: "그대로 주문하기",
      cancelBtnLabel: "다시 담으러 가기",
      bodyContent: (
        <>
          <img
            src="https://file.caretbio.com/caretbio/7410e4e7344808f189a38ee7240ced29.png"
            alt="소량인쇄 안내 이미지"
            style={{
              maxWidth: "294px",
              marginBottom: "10px",
            }}
          />
          <span
            style={{
              color: "#253d4e",
              fontSize: "18px",
            }}
          >
            소량인쇄는 1,000장이 가장 저렴합니다.
          </span>
          <span
            style={{
              color: "#253d4e",
              fontSize: "18px",
            }}
          >
            1,000장 인쇄시 최대 78% 할인이 적용됩니다.
          </span>
          <span
            style={{
              color: "#253d4e",
              fontSize: "15px",
              marginBottom: "20px",
            }}
          >
            (100장 대비 / 장당 가격 기준)
          </span>
        </>
      ),
      onAction: async () => {
        isLoading();

        const res = await smallPackagingAPI(body);
        if (res.Code === "0000") {
          setPrintCartItems([]);
          sessionStorage.setItem("printCart", JSON.stringify([]));
          isLoaded();
          router.push("/mypage/print");
        } else {
          isLoaded();
          failAlert(res.Data?.Msg || "견적 요청 실패");
        }
        closeDefaultModal();
      },
    });
    openDefaultModal();
  };

  useEffect(() => {
    if (isOpen) {
      globalThis.onkeydown = (e) => {
        if (e.code === "Escape") {
          setIsOpen(false);
        }
      };
    }
  }, [isOpen]);

  return (
    <>
      <C.Container className="row">
        <C.CartWrapper>
          <C.CartTableWrapper>
            <>
              <table>
                <thead>
                  <tr>
                    <th>품명</th>
                    <th>수량</th>
                    <th>총 수량</th>
                    <th>판매가</th>
                    <th>인쇄비</th>
                    <th>삭제</th>
                  </tr>
                </thead>
                {printCartItems && printCartItems.length > 0 ? (
                  <tbody>
                    {printCartItems?.map((el, i) => (
                      <tr key={i}>
                        <td className="info">
                          <Link href={`/products/${el.ename}/${el.pcode}/`}>
                            <a
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <img src={el.main_image} alt={el.pname} />
                              <div>{el.pname}</div>
                            </a>
                          </Link>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="d-flex align-items-center w-100">
                            <input
                              className="form-control text-center me-2"
                              type="number"
                              min={1}
                              max={1000}
                              value={el.cnt || 1}
                              onChange={(e) => handleCnt(e, el.pcode)}
                            />
                            개
                          </div>
                        </td>
                        <td>
                          {priceComma(Number(el.quantity) * Number(el.cnt))}개
                        </td>
                        <td>
                          {priceComma(
                            Number(el.discount_price) * Number(el.cnt)
                          )}
                        </td>
                        <td
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          24시간 이내 견적
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => deleteBasketItem(el.pcode)}
                          >
                            삭제
                          </button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={999}>
                        <C.PlusIcon onClick={() => moveToList()}>
                          <i className="fi-rs-plus" />
                        </C.PlusIcon>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={999}>담긴 상품이 없습니다.</td>
                    </tr>
                    <tr>
                      <td colSpan={999}>
                        <C.PlusIcon onClick={() => moveToList()}>
                          <i className="fi-rs-plus" />
                        </C.PlusIcon>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </>
            {/* 모바일 견적 목록 */}
            {printCartItems && (
              <C.MobileCartWrapper>
                {printCartItems?.map((el, i) => (
                  <C.CartProductsMobile key={i}>
                    {printCartItems?.length <= 0 && "견적이 없습니다"}
                    <div className="custome-checkbox me-3">
                      <input
                        type="checkbox"
                        id={`${el.id}`}
                        className="form-check-input"
                        value={el.id ? el.id : ""}
                        onChange={selectItem(i, el)}
                        checked={selectedItem[i]}
                      />
                      <label
                        className="form-check-label d-flex"
                        htmlFor={`${el.id}`}
                        style={{
                          textTransform: "capitalize",
                        }}
                      />
                    </div>
                    <C.ProductMobileImg>
                      <img src={el.main_image} alt="" className="mr-10" />
                    </C.ProductMobileImg>
                    <C.ProductMobileInfo>
                      <h6>{el.pname}</h6>
                      <span>
                        <div className="d-flex align-items-center">
                          <div
                            style={{
                              width: "fit-content",
                              whiteSpace: "nowrap",
                            }}
                            className="me-2"
                          >
                            수량 :
                          </div>
                          <input
                            className="form-control w-100 text-center me-2"
                            type="number"
                            min={1}
                            max={1000}
                            value={el.cnt || 1}
                            onChange={(e) => handleCnt(e, el.pcode)}
                            style={{ height: "40px" }}
                          />
                          개
                        </div>
                      </span>
                      <span>
                        묶음수량 :{" "}
                        {priceComma(Number(el.quantity) * Number(el.cnt))}개
                      </span>
                      <span>
                        판매가 :{" "}
                        {priceComma(Number(el.discount_price) * Number(el.cnt))}
                        원
                      </span>

                      <div>
                        <span>인쇄비 : 24시간 이내 견적</span>
                      </div>
                      <div className="btn_wrapper">
                        <button
                          className="btn btn-sm btn-danger ml-10 mt-5"
                          onClick={() => deleteBasketItem(el.pcode)}
                        >
                          삭제
                        </button>
                      </div>
                    </C.ProductMobileInfo>
                  </C.CartProductsMobile>
                ))}
                <C.PlusIcon onClick={() => moveToList()}>
                  <i className="fi-rs-plus" />
                </C.PlusIcon>
              </C.MobileCartWrapper>
            )}
          </C.CartTableWrapper>
          <>
            <C.InfoWrapper>
              <C.InfoBox>
                <div className="title">
                  <h5>
                    주문인 정보{" "}
                    <span className="input-option" style={{ color: "red" }}>
                      (필수)
                    </span>
                  </h5>
                </div>
                <C.FormInputRow>
                  <C.FormInputBasicSpan>업체명</C.FormInputBasicSpan>
                  <C.FormInputBasicInput
                    type={"text"}
                    placeholder="업체명"
                    onChange={onChangeUserInputs("company")}
                    defaultValue={userCompany?.name || ""}
                  />
                </C.FormInputRow>
                <C.FormInputRow>
                  <C.FormInputBasicSpan>담당자</C.FormInputBasicSpan>
                  <C.FormInputBasicInput
                    type={"text"}
                    placeholder="담당자"
                    onChange={onChangeUserInputs("name")}
                    defaultValue={userInfo?.Member?.name || ""}
                  />
                </C.FormInputRow>
                <C.FormInputRow>
                  <C.FormInputBasicSpan>담당자 연락처</C.FormInputBasicSpan>
                  <C.FormInputBasicInput
                    type={"text"}
                    placeholder="-를 제외한 숫자만"
                    onChange={onChangeUserInputs("phone")}
                    defaultValue={userInfo?.Member?.phone || ""}
                    maxLength={13}
                  />
                </C.FormInputRow>
                <C.FormInputRow>
                  <C.FormInputBasicSpan>담당자 이메일</C.FormInputBasicSpan>
                  <C.FormInputBasicInput
                    type={"text"}
                    placeholder="이메일"
                    onChange={onChangeUserInputs("email")}
                    defaultValue={userInfo?.Member?.email || ""}
                  />
                </C.FormInputRow>
                <div className="title mt-25">
                  <h5>
                    배송지 정보{" "}
                    <span className="input-option" style={{ color: "red" }}>
                      (필수)
                    </span>
                  </h5>
                </div>
                <C.AddressSearch>
                  <C.FormInputBasicSpan>주소</C.FormInputBasicSpan>
                  <div>
                    <C.FormBasicBtn type="button" onClick={onClickHandleModal}>
                      주소검색
                    </C.FormBasicBtn>
                    <input
                      disabled
                      value={
                        userInputs?.addressCode || userCompany?.zipcode || ""
                      }
                      readOnly
                    />
                  </div>
                </C.AddressSearch>
                <C.FormInputRow>
                  <C.FormInputBasicSpan></C.FormInputBasicSpan>
                  <C.FormInputBasicInput
                    disabled
                    address={true}
                    readOnly
                    value={pickAddress || userCompany?.doro_addr || ""}
                  />
                </C.FormInputRow>
                <C.FormInputRow>
                  <C.FormInputBasicSpan></C.FormInputBasicSpan>
                  <C.FormInputBasicInput
                    placeholder="상세주소 입력"
                    address={true}
                    value={
                      userInputs?.detail_addr || userCompany?.detail_addr || ""
                    }
                    onChange={onChangeUserInputs("detail_addr")}
                  />
                </C.FormInputRow>
                <div className="title mt-25">
                  <h5>배송 메세지</h5>
                </div>
                <textarea
                  placeholder={"배송 시 요청할 내용을 작성해주세요."}
                  onChange={onChangeUserInputs("message")}
                />
              </C.InfoBox>
              <C.InfoBox>
                <div className="title">
                  <h5>포장 상품 정보</h5>
                </div>
                <C.FormInputLargeRow>
                  <C.FormInputLargeSpan>
                    <span>포장하시는 상품 정보를 모두 입력해주세요.</span>
                    <span className="example">{`예시) 4kg / 화장품`}</span>
                  </C.FormInputLargeSpan>
                  <C.FormInputBasicInput
                    placeholder="상품 정보 입력"
                    full
                    onChange={onChangeUserInputs("productInfo")}
                  />
                </C.FormInputLargeRow>
                <C.FormInputLargeRow>
                  <C.FormInputLargeSpan>
                    <span>
                      파일 업로드
                      <span className="input-option" style={{ color: "red" }}>
                        (필수)
                      </span>
                    </span>
                    <div>
                      <a
                        href="https://file.caretbio.com/caretbio/칼렛스토어_소량인쇄_칼선가이드_240403153610.Zip"
                        target="__blank"
                        className="btn btn-small w-fit"
                      >
                        칼선 다운로드
                      </a>
                    </div>
                  </C.FormInputLargeSpan>
                  <C.FileUploadWrapper>
                    <CustomFileInput
                      handleFiles={onChangeFiles}
                      ment={
                        ((userInputs?.editYn === "TYPE0" ||
                          !userInputs?.editYn) &&
                          "칼선 도안을 업로드 해주세요.") ||
                        (userInputs?.editYn === "TYPE1" &&
                          "로고를 업로드 해주세요.") ||
                        (userInputs?.editYn === "TYPE2" && "")
                      }
                    />
                  </C.FileUploadWrapper>
                  <span className="mt-10">
                    * 로고파일 또는 로고가 배치된 칼선도안을 업로드해주세요 (ai
                    파일)
                  </span>
                  <span>
                    * 로고가 준비되어 있지 않은 경우에는 관련 이미지를
                    업로드해주세요 (파일 형식 무관)
                  </span>
                </C.FormInputLargeRow>
                <C.FormInputLargeRow>
                  <div className="title mt-25">
                    <h5>선택 사항</h5>
                  </div>
                  <C.FormInputRow>
                    <C.FormInputBasicSpan large>
                      디자인 작업
                    </C.FormInputBasicSpan>
                    <C.FormInputBasicSelect
                      address={true}
                      value={userInputs?.editYn || "TYPE0"}
                      onChange={onChangeUserInputs("editYn")}
                    >
                      <option value={"TYPE0"}>선택 안함</option>
                      <option value={"TYPE1"}>도안 칼선배치</option>
                      <option value={"TYPE2"}>
                        디자인 서비스(별도 비용 상담)
                      </option>
                    </C.FormInputBasicSelect>
                  </C.FormInputRow>
                  <span>
                    * 로고파일이 있지만 일러스트 작업이 어려우신 칼선도안 배치를
                    선택해주세요.
                  </span>
                  <span>
                    * 로고파일이 없는 경우 디자인 서비스를 선택해주세요.
                  </span>
                  <span className="d-flex justify-content-end mt-5">
                    <a
                      href="/customizing/design-service"
                      target="__blank"
                      className="btn btn-small w-fit"
                    >
                      디자인 서비스 보러가기
                    </a>
                  </span>
                </C.FormInputLargeRow>
                <C.FormInputLargeRow>
                  <div className="title">
                    <h5>요청 사항 </h5>
                  </div>
                  <textarea
                    placeholder={"견적시 요청할 내용을 작성해주세요."}
                    onChange={onChangeUserInputs("content")}
                  />
                </C.FormInputLargeRow>
              </C.InfoBox>
            </C.InfoWrapper>
            <C.CartBtnWrapper>
              <button className="btn btn-md" onClick={confirmCustomizing}>
                {router.query.type === "direct" ? "" : "선택"} 견적 요청
              </button>
            </C.CartBtnWrapper>
          </>
        </C.CartWrapper>
      </C.Container>
      {isOpen && (
        <PostCode
          onClickHandleModal={onClickHandleModal}
          onCompletePostCode={onCompletePostCode}
        />
      )}
      {pickAddress && (
        <div style={{ display: "hidden" }}>
          <KakaoMap
            userInputs={userInputs}
            setUserInputs={setUserInputs}
            address={pickAddress}
          />
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
  closeDefaultModal,
  modifyDefaultModal,
  openDefaultModal,
};

export default connect(null, mapDispatchToProps)(PrintCart);
